var scope_0 = require('/Users/ryan.parr/Documents/Apps/sprinklr.design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1368d07b2d8f7e2ba6f12d0fe388a253.js').default;
var scope_1 = require('/Users/ryan.parr/Documents/Apps/sprinklr.design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/35bab8c7d29ea4738cfc79548553edc9.js').default;
var scope_2 = require('/Users/ryan.parr/Documents/Apps/sprinklr.design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7f81797e036d3bb514665cdead417e29.js').default;
var scope_3 = require('/Users/ryan.parr/Documents/Apps/sprinklr.design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8cf37fb3fde340748daec27508191d0a.js').default;
var scope_4 = require('/Users/ryan.parr/Documents/Apps/sprinklr.design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_5 = require('/Users/ryan.parr/Documents/Apps/sprinklr.design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/efeba8b1ec80b198eecda1a86f9cb5ea.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    